<template>
  <!-- eslint-disable vue/no-v-html -->
  <v-alert
    class="flash-modal t-flash-modal"
    :value="true"
    :type="type"
    v-html="modal.data.message"
  />
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'FlashModal',
    props: {
      type: {
        required: true,
        type: String
      }
    },
    data () {
      return {
        timer: undefined
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    },
    created () {
      const { redirectPath } = this.modal.data
      const { onComplete } = this.modal.options

      this.timer = setTimeout(() => {
        this.closeModal()

        if (redirectPath != null) {
          this.$router.push(redirectPath)
        }

        if (typeof onComplete === 'function') {
          onComplete()
        }
      }, this.modal.timeout)
    },
    beforeDestroy () {
      clearTimeout(this.timer)
    },
    methods: {
      ...mapActions('modal', ['closeModal'])
    }
  }
</script>

<style lang="scss">
  .flash-modal {
    font-size: 16px;
    font-weight: 400;
    margin-top: 0;
    margin-bottom: 0;
  }
</style>
